import { Model, Requestor, Request } from '@viddsee/server-api-client';
import { commonApi } from '@/scripts/webcall/v3/common';
import { CardTransformer } from './CardInfoCompat/CardTransformer';
import { VideoInfoCardCompat } from '@/scripts/models/CardInfoCompat/VideoInfoCardCompat';

export interface VideoRelatedEndpointInfoPayload {
  info: Model.VideoCollection.Info;
  publicUrl?: string | null;
  author?: any;
}

export class VideoRelatedEndpoint implements Model.Video.RelatedVideoEndpoint {
  id: string;

  title: string;

  infoEndpoint: string | null;

  videosEndpoint: string;

  type: string;

  videoTransformer: CardTransformer<VideoInfoCardCompat>;

  constructor({
    title,
    infoEndpoint,
    videosEndpoint,
    type,
  }: Model.Video.RelatedVideoEndpoint) {
    this.id = `${type}-${title}`;
    this.title = title;
    this.type = type;

    this.infoEndpoint = infoEndpoint;
    this.videosEndpoint = videosEndpoint;
    this.videoTransformer = {};
  }

  async getVideos(params: Request.Pagination.Options = {}): Promise<Model.Pagination.PaginatedItemsResponse<Model.Video.Info> | null> {
    if (!this.videosEndpoint) return Promise.resolve(null);

    const correctedEndpoint = this.videosEndpoint.replace(/^\/v3\//, '/');

    const { data: paginatedVideoInfos } = await commonApi.get({ url: correctedEndpoint }, params);
    return paginatedVideoInfos as Model.Pagination.PaginatedItemsResponse<Model.Video.Info>;
  }

  async getInfo(): Promise<VideoRelatedEndpointInfoPayload | null> {
    if (!this.infoEndpoint) return Promise.resolve(null);

    const correctedEndpoint = this.infoEndpoint.replace(/^\/v3\//, '/');

    const { data: videoCollectionInfo } = await commonApi.get({ url: correctedEndpoint }) as Requestor.ResponseWrapper<Model.VideoCollection.Info>;
    return ({ info: videoCollectionInfo });
  }
}
